import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon38: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 18.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 18" width={width} height={height} {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.851 0C15.1 0 15.301 0.201997 15.301 0.449997V3.517L17.903 6.767L17.913 6.786L17.924 6.797L17.94 6.83501C17.951 6.85501 17.961 6.875 17.97 6.89799L17.986 6.94701C17.991 6.96801 17.991 6.988 17.993 7.007L18 7.048V14.498C18 15.26 17.75 15.959 17.337 16.534C17.323 16.555 17.317 16.578 17.3 16.597C17.288 16.61 17.273 16.616 17.259 16.628C16.619 17.456 15.626 18 14.499 18H3.50201C2.39501 18 1.41798 17.473 0.776978 16.669C0.746978 16.649 0.715979 16.635 0.690979 16.608C0.653979 16.565 0.629985 16.519 0.609985 16.469C0.225985 15.907 0 15.229 0 14.498V7.048C0 7.032 0.00599561 7.016 0.00799561 7C0.0109956 6.978 0.0130195 6.957 0.0200195 6.935C0.0300195 6.9 0.0429741 6.86701 0.0609741 6.83501C0.0679741 6.82301 0.0689888 6.808 0.0759888 6.797C0.0799888 6.792 0.0850127 6.791 0.0880127 6.786L0.098999 6.767L2.70099 3.51601V0.449997C2.70099 0.201997 2.902 0 3.151 0H14.851ZM9.59802 10.363C9.25902 10.06 8.74703 10.059 8.40503 10.363L1.66901 16.341C2.13901 16.81 2.78701 17.1 3.50201 17.1H14.499C15.215 17.1 15.863 16.809 16.333 16.34L9.59802 10.363ZM0.900024 7.892V14.498C0.900024 14.892 0.994978 15.262 1.15198 15.596L5.98602 11.307L0.900024 7.892ZM17.1 7.892L12.017 11.307L16.849 15.595C17.006 15.26 17.1 14.891 17.1 14.498V7.892ZM14.401 0.900002H3.60101V8.62199L6.68103 10.689L7.80701 9.69C8.48901 9.083 9.51798 9.08499 10.196 9.69099L11.321 10.689L14.401 8.621V0.900002ZM2.70099 4.95599L1.10699 6.94701L2.70099 8.017V4.95599ZM15.301 4.95799V8.017L16.894 6.94701L15.301 4.95799ZM12.15 5.39999C12.399 5.39999 12.6 5.60201 12.6 5.85001C12.6 6.09801 12.399 6.3 12.15 6.3H5.84998C5.60198 6.3 5.40002 6.09801 5.40002 5.85001C5.40002 5.60201 5.60198 5.39999 5.84998 5.39999H12.15ZM12.15 2.7C12.399 2.7 12.6 2.90199 12.6 3.14999C12.6 3.39799 12.399 3.60001 12.15 3.60001H5.84998C5.60198 3.60001 5.40002 3.39799 5.40002 3.14999C5.40002 2.90199 5.60198 2.7 5.84998 2.7H12.15Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
